import React, { useRef, useState } from "react";
import styles from "./editprofile.module.scss";
import { useDispatch, useSelector } from "react-redux";
import DefaultPicture from "../../assets/images/default_user.png";
import { FormGroup, Label } from "reactstrap";
import Textfield from "../Shared/Textfield";
import { useFormik } from "formik";
import Button from "../Shared/Button";
import { toast } from "react-toastify";
import { AddProfilePicture, updateAccount } from "../../helpers/service";
import * as yup from "yup";
import { authenticateUser } from "../Redux/Reducer/authReducer";
import PencilIcon from "../../assets/images/pencil-icon.svg";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";

const EditProfileSchema = yup.object().shape({
  firstName: yup.string().required("Required"),
  lastName: yup.string().required("Required"),
});

const EditProfile = () => {
  const fileInput = useRef();
  const userData = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const userRole = userData?.role;
  const userName = userData?.name.split(" ");
  const firstName = userName?.[0] || "";
  const lastName = userName?.slice(1)?.join(" ") || "";
  const pictureUrl = userData?.profileUrl || "";
  const [url, setUrl] = useState(pictureUrl);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName,
      lastName,
      email: userData?.email || "",
      city: "",
      state: "",
      country: "",
      zip_code: "",
      profile_picture: url,
    },
    validationSchema: EditProfileSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = (values) => {
    const name = (values?.firstName || "") + " " + (values.lastName || "");
    const data = {
      // userId: userData?.id || "",
      name,
      bio: userData?.bio ? userData?.bio : "",
      email: userData?.email,
      phone: userData?.phone ? userData?.phone : 0,
      profileUrl: url ? url : userData?.profileUrl,
      role: userData?.role,
    };

    const idToken = userData?.idToken;
    if (pictureUrl === url) {
      setLoading(true);
      updateAccount(data, idToken)
        .then((resp) => {
          toast.success("Details updated successfully!..");
          setLoading(false);
          dispatch(
            authenticateUser({
              ...userData,
              name,
            })
          );
          formik.setSubmitting(false);
        })
        .catch((err) => {
          toast.error("Something went wrong. Please try again");
          formik.setSubmitting(false);
        });
    } else if (url) {
      setLoading(true);
      updateAccount(data, idToken)
        .then((resp) => {
          setLoading(false);
          toast.success("Details updated successfully!..");
          AddProfilePicture(
            {
              email: userData.email,
              image: formik?.values?.profile_picture,
            },
            idToken
          )
            .then((backendResponse) => {
              dispatch(
                authenticateUser({
                  ...userData,
                  name,
                  profileUrl: backendResponse?.data || "",
                })
              );
              formik.setSubmitting(false);
            })
            .catch((err) => {
              toast.error("Something went wrong. Please try again");
              formik.setSubmitting(false);
            });
        })
        .catch((err) => {
          toast.error("Something went wrong. Please try again");
          formik.setSubmitting(false);
        });
    }
  };
  return (
    <div className={styles["editprofile_container"]}>
      {loading && <CuteMascotSpinner />}
      <div className={styles["image_container"]}>
        <h4>
          {userRole.charAt(0).toUpperCase() +
            userRole.slice(1).toLowerCase() +
            " Profile"}
        </h4>
        <div className={styles["image_wrapper"]}>
          <div className={styles["label_container"]}>
            <h5>{`${firstName} ${lastName}`.toUpperCase()}</h5>
          </div>
          <div className={styles["label_container"]}>
            <p>{userRole.toUpperCase()}</p>
          </div>
          <div>
            <img
              width={100}
              height={100}
              alt=""
              src={url}
              className={styles["profile_image"]}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = DefaultPicture;
              }}
              onClick={() => fileInput.current.click()}
            />

            <div
              className={styles["icon_container"]}
              onClick={() => fileInput.current.click()}
            >
              <img src={PencilIcon} alt="edit" width={20} height={20} />
              <input
                className={styles["input"]}
                type="file"
                accept="image/*"
                ref={fileInput}
                onChange={(e) => {
                  const file = e.target.files[0];
                  const url = URL.createObjectURL(file);
                  setUrl(url);
                  formik.setFieldValue("profile_picture", file);
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <FormGroup className={styles["form_group"]}>
            <Label className={styles["form_input_label"]}>Email Address</Label>
            <Textfield
              type="email"
              onChange={formik.handleChange}
              value={formik?.values?.email}
              name="email"
              className={styles["form_input"]}
              error={formik?.errors?.email}
              touched={formik?.touched?.email}
              disabled={true}
            />
          </FormGroup>
        </div>
      </div>
      <div className={styles["namefields_container"]}>
        <h4>Edit Profile</h4>
        <div className={styles["inputfields_container"]}>
          <div className={styles["inputfield_container"]}>
            <FormGroup className={styles["form_group"]}>
              <Label className={styles["form_input_label"]}>First Name</Label>
              <Textfield
                onChange={formik.handleChange}
                value={formik?.values?.firstName}
                name="firstName"
                className={styles["form_input"]}
                error={formik?.errors?.firstName}
                touched={formik?.touched?.firstName}
              />
            </FormGroup>
          </div>
          <div className={styles["inputfield_container"]}>
            <FormGroup className={styles["form_group"]}>
              <Label className={styles["form_input_label"]}>Last Name</Label>
              <Textfield
                onChange={formik.handleChange}
                value={formik?.values?.lastName}
                name="lastName"
                className={styles["form_input"]}
                error={formik?.errors?.lastName}
                touched={formik?.touched?.lastName}
              />
            </FormGroup>
          </div>
        </div>
        <div className={styles["submit_button"]}>
          <Button
            text="Save"
            className={styles["save_button"]}
            onClick={formik.handleSubmit}
            disabled={formik.isSubmitting}
          />
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
